import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ITableServerResponseFilter } from 'src/app/common/interfaces/table/table-server-filter-response.interface';
import { ITableServerFilter } from 'src/app/common/interfaces/table/table-server-filter.inteface';
import { lastValueFrom } from 'rxjs';
import { AbstractRtpAccountActivityRespondentService } from '../abstraction/abstract.account-activity-respondent.service';
import { IRtpNetActivityStatus } from '../../interfaces/account-activity/net-activity-status';

@Injectable({
  providedIn: 'root',
})
export class MockRtpAccountActivityRespondentService extends AbstractRtpAccountActivityRespondentService {
  private tableFilterJson = 'assets/mocks/rtp/accountactivity/respondent/tableFilter.json';
  private netActvityStatusJson =
    'assets/mocks/rtp/accountactivity/respondent/getCurrentNetActivityStatus.json';

  constructor(private http: HttpClient) {
    super();
  }

  tableFilter(filter: ITableServerFilter): Promise<ITableServerResponseFilter | undefined> {
    return lastValueFrom(this.http.get<ITableServerResponseFilter>(this.tableFilterJson));
  }

  tableExportCSV(filter: ITableServerFilter): Promise<Blob | undefined> {
    throw new Error('Method not implemented.');
  }

  tableExportExcel(filter: ITableServerFilter): Promise<Blob | undefined> {
    throw new Error('Method not implemented.');
  }

  override getCurrentActivity(): Promise<string | undefined> {
    return lastValueFrom(this.http.get<{ currentNetActivity: string }>(this.netActvityStatusJson))
      .then(response => response.currentNetActivity)
      .catch(() => undefined);
  }
}
